import React from 'react';
import { TrendingUp, CheckCircle2, XCircle, RotateCcw, Clock, Wallet, Users, PhoneOff, Percent } from 'lucide-react';

export const fmtBRL = (v) => (v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
export const fmtNum = (v) => (v || 0).toLocaleString('pt-BR');

const Kpi = ({ icone: Icone, rotulo, valor, sub, cor, testid }) => (
  <div className="relative overflow-hidden rounded-2xl border border-gray-200 dark:border-purple-900/50 bg-white dark:bg-[#15082a] p-4 group hover:-translate-y-0.5 transition-transform" data-testid={testid}>
    <div className={`absolute -right-6 -top-6 h-20 w-20 rounded-full opacity-15 ${cor}`} />
    <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-purple-300/80">
      <Icone className="w-3.5 h-3.5" /> {rotulo}
    </div>
    <p className="mt-2 text-2xl font-bold tabular-nums text-gray-900 dark:text-white">{valor}</p>
    {sub && <p className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">{sub}</p>}
  </div>
);

export const DataCenterKpis = ({ k }) => {
  if (!k) return null;
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3" data-testid="dc-kpis">
      <Kpi icone={TrendingUp} rotulo="Vendas" valor={fmtNum(k.total)} sub={`${k.vendedores_ativos} vendedor(es) ativo(s)`} cor="bg-purple-500" testid="dc-kpi-total" />
      <Kpi icone={CheckCircle2} rotulo="Instaladas" valor={fmtNum(k.instaladas)} sub={k.dias_ate_instalar != null ? `${k.dias_ate_instalar} dias até instalar` : 'sem instalação no período'} cor="bg-emerald-500" testid="dc-kpi-instaladas" />
      <Kpi icone={Percent} rotulo="Conversão" valor={`${k.conversao}%`} sub="instaladas ÷ vendas" cor="bg-cyan-500" testid="dc-kpi-conversao" />
      <Kpi icone={Clock} rotulo="Em andamento" valor={fmtNum(k.em_andamento)} sub="aguardando BKO/instalação" cor="bg-amber-500" testid="dc-kpi-andamento" />
      <Kpi icone={XCircle} rotulo="Canceladas" valor={fmtNum(k.canceladas)} sub="inclui reprovadas e bloqueadas" cor="bg-red-500" testid="dc-kpi-canceladas" />
      <Kpi icone={RotateCcw} rotulo="Devolvidas" valor={fmtNum(k.devolvidas)} sub="aguardando correção" cor="bg-orange-500" testid="dc-kpi-devolvidas" />
      <Kpi icone={Wallet} rotulo="Valor instalado" valor={fmtBRL(k.valor_instalado)} sub={`ticket médio ${fmtBRL(k.ticket_medio)}`} cor="bg-fuchsia-500" testid="dc-kpi-valor" />
      <Kpi icone={PhoneOff} rotulo="Não Perturbe" valor={k.lnp_pct_bloqueadas != null ? `${k.lnp_pct_bloqueadas}%` : '—'} sub={k.lnp_consultadas ? `${k.lnp_bloqueadas} de ${k.lnp_consultadas} consultadas` : 'nenhuma consulta no período'} cor="bg-rose-600" testid="dc-kpi-lnp" />
    </div>
  );
};

export const Painel = ({ titulo, descricao, children, acao, className = '', testid }) => (
  <section className={`rounded-2xl border border-gray-200 dark:border-purple-900/50 bg-white dark:bg-[#15082a] p-4 ${className}`} data-testid={testid}>
    <div className="flex items-start justify-between gap-3 mb-3">
      <div>
        <h3 className="text-sm font-bold text-gray-900 dark:text-white flex items-center gap-2">{titulo}</h3>
        {descricao && <p className="text-[11px] text-gray-500 dark:text-gray-400">{descricao}</p>}
      </div>
      {acao}
    </div>
    {children}
  </section>
);

export const Vazio = ({ texto = 'Sem dados no período' }) => (
  <p className="py-8 text-center text-xs text-gray-400 flex items-center justify-center gap-2"><Users className="w-4 h-4" /> {texto}</p>
);
